import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { ProFormaModelIds } from 'constants/proForma';
import { SensitivityValue } from '../SensitivityTable/types';

export const GROSS_RENT_LABEL = 'gross rent';

export const getGrossRentLabel = (proFormaModelId?: number) => {
    if (proFormaModelId === ProFormaModelIds.RETAIL
        || proFormaModelId === ProFormaModelIds.OFFICE
        || proFormaModelId === ProFormaModelIds.INDUSTRIAL) {
        return 'Total rental income';
    }
    return 'Gross rent';
};

export const getSensitivityConfig = (showCents: boolean = false) => {
    const currencyFormat = showCents ? '$0,0.00' : '$0,0';
    const formatter = (value: number | string | undefined) => numeralFormatterCurrency(value, currencyFormat);

    return {
        'Gross rent vs Vacancy rate': {
            displayValue: 'netOperatingIncome',
            formatter,
        },
        'Exit cap rate vs Gross rent': {
            displayValue: 'exitValuation',
            formatter,
        },
        'Lease-up pace vs Gross rent': {
            displayValue: 'netOperatingIncome',
            formatter,
        },
        'Operating expenses vs Gross rent': {
            displayValue: 'netOperatingIncome',
            formatter,
        },
        'Exit cap rate vs Hard + soft costs': {
            displayValue: 'exitValuation',
            formatter,
        },
        'Interest rate vs LTC': {
            displayValue: 'constructionDebtAmount',
            formatter,
        },
    } as const;
};

export const getSensitivityOptions = (proFormaModelId?: number) => [
    {
        value: 'Gross Rent vs Vacancy Rate',
        label: `${getGrossRentLabel(proFormaModelId)} vs Vacancy rate`,
        verticalLabel: getGrossRentLabel(proFormaModelId),
        horizontalLabel: 'Vacancy rate',
        increments: { vertical: 0.01, horizontal: 0.01 },
    },
    {
        value: 'Exit Capitalization Rate vs Gross Rent',
        label: `Exit cap rate vs ${getGrossRentLabel(proFormaModelId)}`,
        verticalLabel: 'Exit cap rate',
        horizontalLabel: getGrossRentLabel(proFormaModelId),
        increments: { vertical: 0.001, horizontal: 0.01 },
    },
    {
        value: 'Lease Up Pace vs Gross Rent',
        label: `Lease-up pace vs ${getGrossRentLabel(proFormaModelId)}`,
        verticalLabel: 'Lease-up pace',
        horizontalLabel: getGrossRentLabel(proFormaModelId),
        increments: { vertical: 1, horizontal: 0.01 },
    },
    {
        value: 'Operating Expenses vs Gross Rent',
        label: `Operating expenses vs ${getGrossRentLabel(proFormaModelId)}`,
        verticalLabel: 'Operating expenses',
        horizontalLabel: getGrossRentLabel(proFormaModelId),
        increments: { vertical: 0.01, horizontal: 0.01 },
    },
    {
        value: 'Exit Capitalization Rate vs Hard and Soft Costs',
        label: 'Exit cap rate vs Hard + soft costs',
        verticalLabel: 'Hard + soft costs',
        horizontalLabel: 'Exit cap rate',
        increments: { vertical: 0.001, horizontal: 0.01 },
    },
    {
        value: 'Interest Rate vs Loan to Cost',
        label: 'Interest rate vs LTC',
        verticalLabel: 'Interest rate',
        horizontalLabel: 'LTC',
        increments: { vertical: 0.001, horizontal: 0.01 },
    },
];

export const LOAN_TO_COST = 'Loan to Cost';
export const LOAN_TO_VALUE = 'Loan to Value';
export const LEASE_UP_PACE = 'Lease Up Pace';
export const INTEREST_RATE_VS_LTV = 'Interest Rate vs LTV';

export const EMPTY_DATA_VALUES = [
    { status: 'best' }, { status: 'best' }, { status: 'good' }, { status: 'good' }, { status: 'good' },
    { status: 'best' }, { status: 'best' }, { status: 'good' }, { status: 'good' }, { status: 'good' },
    { status: 'good' }, { status: 'good' }, { status: 'good' }, { status: 'good' }, { status: 'good' },
    { status: 'good' }, { status: 'good' }, { status: 'good' }, { status: 'warning' }, { status: 'warning' },
    { status: 'good' }, { status: 'good' }, { status: 'good' }, { status: 'warning' }, { status: 'danger' },
] as SensitivityValue[];
